import getFunctionName from 'function.prototype.name';
import { abTestVariantConfig } from '../constants/abTestConfig';
import _ from "lodash";

const getFirebaseExperiments = (state: {}) => {
  return _.get(state, `abTest.firebaseExperiments`, {});
}

const getOptimizeExperiments = (state: {}) => {
  return _.get(state, `abTest.optimizeExperiments`, {});
}

/**
 * Return remote config in string format of <key>:<value>,<key>:<value>,... 
 */
export const getExperimentsInStr = (state: any): string => {
  const firebaseExperiments = getFirebaseExperiments(state);

    let experimentsArr = [];
    for (const [key, value] of Object.entries(firebaseExperiments)) {
        experimentsArr.push(`${key}:${value}`);
    }

    const optimizeExperiments = getOptimizeExperiments(state);
    for (const [key, value] of Object.entries(optimizeExperiments)) {
        experimentsArr.push(`${key}:${value}`);
    }
    return experimentsArr && experimentsArr.length > 0 ? experimentsArr.join(",") : '';
}

